import { Filter } from '../core/typings/api';

interface JumpListOption {
  displayText: string;
  value: string;
  selectedValue?: boolean;
  name?: string;
}

/**
 * Remove this method once the Russia situation has blown over. See this ticket: https://stadion-uci.atlassian.net/browse/UCIKB-410
 * @param filterItems
 */
const removeCountries = (filterItems: Filter[]) => (
  filterItems.filter((item) => item.code !== 'RUS' && item.code !== 'BLR')
);

/**
 * Map the current model to the JumpListOption type
 * @param filterItems
 * @returns
 */
const mapFilterType = (filterItems: Filter[]) => {
  const filteredCountries = removeCountries(filterItems);
  const mappedItems: JumpListOption[] = [];
  filteredCountries.map((item) => (
    mappedItems.push({
      displayText: item.text,
      value: item.code,
      selectedValue: item.selected,
    })
  ));
  return mappedItems;
};

export default mapFilterType;
